<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
<path d="M6 4.54028L10 8.54028L6 12.5403" stroke="#386280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>